import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale, is24HourFormat } from '@components/frame';
import { isPhone, formatSinceTime } from '@helpers';

import { font } from '@styles/fonts';
import { getBoxShadowStyle } from '@styles/shadow';

import ConnectorStatus from './connectorStatus';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({ C, version, updatedAt, fileConnectorStatus, connected, totalFiles, totalSize, onlyMainBlock, totalBytesSentPerSecond }) => {
  const checkValue = (val) => {
    return val ? val : ' - ';
  };

  return (
    <View
      style={[
        getBoxShadowStyle({ type: 'Field', C }),
        {
          width: '100%',
          height: isPhone ? scale(180) : scale(200),
          borderRadius: scale(SCREEN_BORDER_RADIUS),
          backgroundColor: C('Background/Light/Field'),
        },
      ]}
    >
      <View
        style={{
          flexDirection: 'row',
          marginTop: scale(12),
          width: scale(220),
          paddingLeft: scale(14),
        }}
      >
        <Text style={[font['Title 2'], { color: C('Label/Light/Primary') }]}>{i18n.t('File Connector')}</Text>
      </View>
      <View
        style={{
          height: scale(22),
          width: scale(190),
          paddingLeft: scale(14),
          marginBottom: isPhone ? scale(6) : scale(11),
        }}
      >
        <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{`${i18n.t('Version')}: ${checkValue(version)}`}</Text>
      </View>
      <ConnectorStatus {...{ connected, C, fileConnectorStatus, totalFiles, totalBytesSentPerSecond, totalSize, onlyMainBlock }} />
      <View
        style={{
          height: scale(42),
          paddingLeft: scale(14),
          marginTop: isPhone ? scale(7) : scale(12),
          marginBottom: scale(10),
          width: scale(190),
        }}
      >
        <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary') }]}>
          {`${i18n.t('Last seen')}: \n${formatSinceTime(updatedAt, is24HourFormat, true)}`}
        </Text>
      </View>
    </View>
  );
};
